var strings = {};
var langs = {};

// Elements registered for live re-translation on language switch.
// Each entry: { el, key, attr } where attr is "text" or an attribute name.
var subs = [];

async function init() {
    var res = await fetch("/i18n/langs.json");
    var json = await res.json();
    langs = json;
}

async function loadLanguage(lang) {
    if (!(lang in langs)) throw new Error;
    var res = await fetch("/i18n/" + lang + ".json");
    var json = await res.json();
    strings = json;
}

function getString(str) {
    if (str in strings)
        return strings[str];
    else
        return str;
}

function getLanguages() {
    return langs;
}

// Register an element to be re-translated whenever the language changes.
// Usage:
//   t(el, "Some English key")              -> sets el.textContent
//   t(el, "Some English key", "aria-label")-> sets el's aria-label attribute
// The element keeps displaying the CURRENT language immediately, and
// retranslate() (called after i18n.loadLanguage) updates every connected
// element without tearing down the DOM. This is what lets the language
// switcher update the UI in place instead of rebuilding the whole app.
function t(el, key, attr) {
    attr = attr || "text";
    var sub = { el: el, key: key, attr: attr };
    applySub(sub);
    subs.push(sub);
    return el;
}

function applySub(sub) {
    var v = getString(sub.key);
    if (sub.attr === "text") sub.el.textContent = v;
    else sub.el.setAttribute(sub.attr, v);
}

function retranslate() {
    for (var i = 0; i < subs.length; i++) {
        var s = subs[i];
        if (s.el && s.el.isConnected) applySub(s);
    }
    // Also re-translate any element tagged with a data-i18n attribute
    // (used for UI built without a direct reference, e.g. dialog hide
    // buttons created inside pbfe). Keeps those in sync on language switch.
    if (typeof document !== "undefined") {
        var nodes = document.querySelectorAll("[data-i18n]");
        for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.isConnected) n.textContent = getString(n.getAttribute("data-i18n"));
        }
    }
    // Notify dynamic UI (state-dependent labels like the panel hide/show
    // toggle) so they can re-localize themselves after a language switch.
    if (typeof window !== "undefined") {
        window.dispatchEvent(new Event("i18n:change"));
    }
}

// Convenience for elements created without a tracked reference: set the
// data-i18n attribute and the initial (current-language) text in one call.
function setI18n(el, key) {
    el.setAttribute("data-i18n", key);
    el.textContent = getString(key);
    return el;
}

// Expose a translator so generic UI builders (pbfe) can localize text they
// create without importing i18n directly.
if (typeof window !== "undefined") {
    window.i18nTranslate = function (k) { return getString(k); };
}

var i18n = {
    init,
    loadLanguage,
    getString,
    getLanguages
};
export default i18n;
export var _ = getString;
export { t, setI18n, retranslate };